// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkIQdk1aVbmOyGDub0kyP1pywwOfggRyU",
  authDomain: "cheerocracy-a270c.firebaseapp.com",
  projectId: "cheerocracy-a270c",
  storageBucket: "cheerocracy-a270c.firebasestorage.app",
  messagingSenderId: "660118517717",
  appId: "1:660118517717:web:3d629517b236a4d51c2f5c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;